import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const InfoIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 11c.6 0 1 .4 1 1v4a1 1 0 1 1-2 0v-4c0-.6.4-1 1-1Zm0-4a1 1 0 1 0 0 2 1 1 0 1 0 0-2Z" />
    <path
      fillRule="evenodd"
      d="M1 12a11 11 0 1 1 22 0 11 11 0 0 1-22 0Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default InfoIcon;
